export default { 
  render: ({ href, type, rel }, callback) => {
    const $link = document.createElement('link');
    $link.href = href;
    $link.type = type;
    $link.rel = rel;
    document.getElementsByTagName('head')[0].appendChild($link);
    $link.onload = callback
  }
};


// WEBPACK FOOTER //
// ./src/services/appendStyles.js